import React, { useState, useRef, useEffect } from 'react';
import { LogOut, User, ChevronDown } from 'lucide-react';
import { NavLink } from 'react-router-dom';

const UserMenu = ({ user, onLogout }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    if (!user) return null;

    // Get initials from email or generic 'U'
    const initials = user.email ? user.email.substring(0, 2).toUpperCase() : 'U';

    return (
        <div className="relative" ref={menuRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center space-x-3 p-2 rounded-full hover:bg-gray-100 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
            >
                <div className="h-9 w-9 rounded-full bg-primary-100 flex items-center justify-center text-primary-700 font-bold border border-primary-200 shadow-sm">
                    {initials}
                </div>
                <div className="hidden md:block text-left">
                    <p className="text-sm font-medium text-gray-700 max-w-[150px] truncate">{user.email}</p>
                </div>
                <ChevronDown
                    className={`h-4 w-4 text-gray-500 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                />
            </button>

            {isOpen && (
                <div className="absolute right-0 mt-2 w-72 rounded-xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 z-50 transform origin-top-right transition-all duration-200 ease-out">
                    <div className="p-4 border-b border-gray-100">
                        <div className="flex items-center space-x-3">
                            <div className="h-12 w-12 rounded-full bg-primary-50 flex items-center justify-center text-xl font-bold text-primary-600">
                                {initials}
                            </div>
                            <div className="flex-1 min-w-0">
                                <p className="text-sm font-bold text-gray-900 truncate">
                                    {user.email}
                                </p>
                                <p className="text-xs text-gray-500 truncate">
                                    Franchise Owner
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="p-2 space-y-1">
                        <NavLink
                            to="/profile"
                            onClick={() => setIsOpen(false)}
                            className="flex items-center w-full px-4 py-2.5 text-sm text-gray-700 rounded-lg hover:bg-gray-50 hover:text-primary-600 transition-colors"
                        >
                            <User className="mr-3 h-4 w-4" />
                            My Profile
                        </NavLink>
                    </div>

                    <div className="p-2 border-t border-gray-100">
                        <button
                            onClick={() => {
                                setIsOpen(false);
                                onLogout();
                            }}
                            className="flex items-center w-full px-4 py-2.5 text-sm text-red-600 rounded-lg hover:bg-red-50 hover:text-red-700 transition-colors"
                        >
                            <LogOut className="mr-3 h-4 w-4" />
                            Sign Out
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UserMenu;
